(() => {
  if (customElements.get('sl-card-colors')) return;

  class SLCardColors extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => this.selectColor(event));
    }

    selectColor(event) {
      const link = event.target.closest('a[data-sl-color-id]');
      if (!link || !this.contains(link) || event.defaultPrevented ||
          event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const currentCard = this.closest('.product-item');
      const productId = link.dataset.slColorId;
      if (!currentCard) return;
      if (currentCard.dataset.productId === productId) {
        event.preventDefault();
        return;
      }

      const template = Array.from(this.querySelectorAll('template[data-sl-color-card]'))
        .find((item) => item.dataset.slColorCard === productId);
      const replacement = template?.content.querySelector('.product-item')?.cloneNode(true);
      const slot = replacement?.querySelector('[data-sl-colors-slot]');
      // Keep the ordinary product link usable if a snapshot is unavailable.
      if (!slot) return;
      event.preventDefault();

      const restoreFocus = document.activeElement === link;
      const title = replacement.querySelector('.card-title')?.textContent.trim() || link.title;
      this.querySelectorAll('a[data-sl-color-id]').forEach((option) => {
        option.setAttribute('aria-current', String(option.dataset.slColorId === productId));
      });

      // Move the group intact: its order and all snapshots survive every swap.
      slot.replaceWith(this);
      currentCard.replaceWith(replacement);
      if (restoreFocus) link.focus({ preventScroll: true });
      this.querySelector('[data-sl-color-status]').textContent = title;
      replacement.dispatchEvent(new CustomEvent('sl:card-color-change', {
        bubbles: true, detail: { productId }
      }));
    }
  }

  customElements.define('sl-card-colors', SLCardColors);
})();
